import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import {warupList} from "@/api/sms/warup";

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		form: {},
		depotList: []
	},
	actions: {
		async getList({ state, dispatch }, payload) {
			await wait(dispatch, 'sms.warup.list', async function () {
				const { searchForm } = state;
				await dispatch('getData', {
					caller: warupList,
					options: {
						startTime: searchForm.time && new Date(searchForm.time[0]).getTime() / 1000,
						endTime: searchForm.time && new Date(searchForm.time[1]).getTime() / 1000,
						batchNo: searchForm.batchNo,
						depotId:searchForm.depotId,
						opAdminId: searchForm.opAdminId,
						goodsId:searchForm.goodsId,
						skuValue: searchForm.skuValue,
						...payload
					}
				});
			})
		},
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/warup/index.js